
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tier-list/units",
      function () {
        return require("private-next-pages/tier-list/units/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tier-list/units"])
      });
    }
  